import { render } from "./RedeTableView.vue?vue&type=template&id=3d38c63e"
import script from "./RedeTableView.vue?vue&type=script&lang=js"
export * from "./RedeTableView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/salvando-arvores-front/salvando-arvores-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__